module.exports = __webpack_public_path__ + "img/album05_07.c6fb623c.jpg";